import React from "react";
import toast from "react-hot-toast";
import { ItemsAddedToCartBanner } from "@/components/scanToOrder/itemsAddedToCartBanner";
import { CustomerLoggedInBanner } from "@/components/navigationBar/customerLoggedInBanner";
import ReorderedItemAddedToCartBanner from "@/components/reorders/reorderedItemAddedToCartBanner";

export const toastService = {
  notifyItemAdded: () => {
    toast(<ItemsAddedToCartBanner />, {
      duration: 4000,

      style: {
        background: "transparent",
        boxShadow: "none",
        padding: 0,
        marginTop: "100px",
      },
      position: "top-center",
    });
  },
  notifyUserLoggedIn: (isMobileScreen: boolean, customerName?: string) => {
    toast.custom(
      (t) => (
        <CustomerLoggedInBanner
          customerName={customerName}
          visible={t.visible}
          isMobileScreen={isMobileScreen}
        />
      ),
      {
        duration: 4000,
        position: !isMobileScreen ? "top-right" : "bottom-center",
      }
    );
  },
  notifyItemReorderedAddedToCart: (isMobileScreen: boolean, itemName: string) => {
    toast(<ReorderedItemAddedToCartBanner itemName={itemName} />, {
      duration: 4000,
      position: !isMobileScreen ? 'top-right' : 'bottom-center',
      style: {
        background: 'transparent',
        boxShadow: 'none',
        padding: 0,
      },
    });
  },
};
